function debounce(ms = 1000) {
  let tid: number

  return (cb: Function) => {
    clearTimeout(tid)

    tid = setTimeout(cb, ms)
  }
}

export default debounce
